import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { FC } from 'react';
import classes from '../../asset/css/subscription-detail/header.module.css';
import { Summary } from '../../hooks/use-subscription-summary';

dayjs.locale('ja');
export const Header: FC<{ summary?: Summary }> = ({ summary }) => {
  return (
    <div className={classes.header}>
      <h1 className={classes.header_title}>次回お届け情報</h1>
      <p className={classes.header_duedate}>
        変更締切：{summary ? dayjs(summary.nextBillingDate).format('YYYY年 M月DD日（ddd） HH:mm') : ''}
      </p>
    </div>
  );
};
